import * as React from 'react';
import clsx from 'clsx';
import { TextArea } from '@gandi/form';
import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "loadingTextarea": "CodeEditor-loadingTextarea_3Ig0e",
  "loadingTextarea--large": "CodeEditor-loadingTextarea--large_1VLOg"
};
function getComponent() {
  return import( /* webpackChunkName: "CodeEditor" */'@gandi/ui-code');
}

/**
 * Get the number of rows from the file by splitting it on newlines.
 * T66419: Limit to 20 the number of rows
 */
const EDITOR_MAX_ROWS = 20;
/**
 * This component is lazyloaded, it will display a simple textarea on SSR and
 * while loading the actual CodeEditor.
 * NOTE: This is a copy-paste from app-domain.
 */
function CodeEditor({
  type,
  className,
  editorLoaded,
  ...props
}) {
  const {
    __
  } = useTranslator();
  const [editor, setEditor] = React.useState({
    component: undefined,
    grammar: undefined
  });
  React.useEffect(() => {
    let mounted = true;
    // $FlowFixMe[unused-promise]
    getComponent().then(({
      CodeEditor: component,
      zonefile
    }) => {
      // make sure the component is still mounted before re-redering this one. (e.g. fast page change)
      if (mounted) {
        // $FlowFixMe[incompatible-call]
        setEditor({
          component,
          grammar: {
            zonefile
          }
        });
        if (editorLoaded) {
          editorLoaded();
        }
      }
    });
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const isLarge = (props.initialValue || '').split('\n').length > EDITOR_MAX_ROWS;
  if (!editor.component) {
    const {
      contentAttributes,
      lang,
      initialValue,
      height,
      ...textAreaProps
    } = props; // Remove invalid prop

    return (
      /*#__PURE__*/
      // $FlowFixMe[cannot-spread-inexact]: `contentAttributes` are dom properties but inexact
      _jsx(TextArea, {
        name: "code-editor",
        className: clsx('form-control', styles.loadingTextarea, isLarge ? styles['loadingTextarea--large'] : undefined, className),
        value: initialValue,
        ...textAreaProps,
        ...(contentAttributes || {})
      })
    );
  }
  const Editor = editor.component;
  let lang;
  switch (type) {
    case 'zonefile':
      lang = editor.grammar.zonefile();
      break;
    default:
      // nothing to do
      break;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Base, {
      marginBottom: "xsmall",
      color: "light",
      size: "small",
      children: __('💡 You can search in this field by clicking on it and using the keyboard shortcuts Ctrl+F or ⌘+F.')
    }), /*#__PURE__*/_jsx(Editor, {
      className: className,
      lang: lang,
      height: isLarge ? 'large' : 'base',
      ...props
    })]
  });
}
export default CodeEditor;